(function ($) {
  var body = $('body'),
  doc = $(document),
  html = $('html'),
  win = $(window),
  wrapperOverlaySlt = '.wrapper-overlay',
  iconNav;

  $(function () {
    iconNav = $('[data-menu-mb-toggle]');

    doc.ajaxStart(function () {
      ella.isAjaxLoading = true;
    });

    doc.ajaxStop(function () {
      ella.isAjaxLoading = false;
    });

    ella.init();

    doc
    .on('shopify:section:load', ella.initSlideshow)
    .on('shopify:section:unload', ella.initSlideshow)

    .on('shopify:section:load', ella.initSliderFeaturedProducts)
    .on('shopify:section:unload', ella.initSliderFeaturedProducts)

    .on('shopify:section:load', ella.initBrandsSlider)
    .on('shopify:section:unload', ella.initBrandsSlider)
  });

  var ella = {
    ellaTimeout: null,
    isAjaxLoading: false,
    init: function () {
      this.initTracking();
      this.showHideMenuMobile();
      this.closeAllOnMobile();
      this.initCountries();
      this.initDropdownMenu();
      this.initToggleSubMenuMobile();
      this.initAddToCart();
      this.initSliderFeaturedProducts();
      this.initCountdown();
      this.initCountdownNormal();
      this.initLoading();

      if(body.hasClass('template-index') || body.hasClass('template-page')) {
        this.initSlideshow();
        this.initBrandsSlider();
      };

      if(body.hasClass('template-search')) {
        this.initInfiniteScrolling();
      }

      this.initSearch();
      this.productPageInitProductTabs();

      if(body.hasClass('template-product') ) {
        this.changeSwatch('#add-to-cart-form .swatch :radio');
        this.wrapTable();
      }

      this.initBannerModules();
    },

    showHideMenuMobile: function () {
      iconNav.off('click.showMenuMobile').on('click.showMenuMobile', function (e) {
        e.preventDefault();
        e.stopPropagation();

        html.toggleClass('translate-overlay');
        $('.close-menu-mb').toggleClass('menu-open');

        $('.main-menu.jas-mb-style').css({
          "overflow": ""
        });
        $('.site-nav').find('[data-toggle-menu-mb]').parent().next('.sub-menu-mobile').removeClass('sub-menu-open');
      });
    },

    closeAllOnMobile: function () {
      body.off('click.close', wrapperOverlaySlt).on('click.close', wrapperOverlaySlt, function (e) {
        e.preventDefault();
        e.stopPropagation();

        html.removeClass('translate-overlay cart-show customer-show sidebar-opens');
        $('.close-menu-mb').removeClass('menu-open');

        $('.main-menu.jas-mb-style').css({
          "overflow": ""
        });
        $('.site-nav').find('[data-toggle-menu-mb]').parent().next('.sub-menu-mobile').removeClass('sub-menu-open');
      });
    },

    initCountries: function () {
      var $label = $(".js-country-label");

      if ($label.length) {
        $label.off('click.countries').on('click.countries', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var selfNextDropdown = $(this).next();

          if (!selfNextDropdown.is(':visible')) {
            $label.next('.dropdown-menu').hide();
            selfNextDropdown.slideDown(300);
          } else {
            selfNextDropdown.slideUp(300);
          }
        });

        var $items = $(".js-country-item");
        var $input = $("[data-country-input]");
        $items.off("click.countryItem").on("click.countryItem", function(e) {
          $input.val($(this).data("value"));
          var form = $(this).closest("form");
          form.submit();
        });

        var currentItem = $(`.js-country-item[data-value=${window.Shopify.country}`);
        $label.text(currentItem.data("currency"));

        doc.off('click.hideCountries').on('click.hideCountries', function (e) {
          var $dropdown = $('.js-country-menu');

          if (!$dropdown.is(e.target) && !$dropdown.has(e.target).length) {
            $dropdown.slideUp(300);
          }
        });
      }
    },

    initSlideshow: function () {
      var slickSlideshow = $('[data-init-slideshow]');

      if (slickSlideshow.length) {
        slickSlideshow.each(function () {
          var self = $(this);

          if (self.not('.slick-initialized')) {
            self.slick({
              dots: self.data('dots'),
              slidesToScroll: 1,
              verticalSwiping: false,
              fade: self.data('fade'),
              cssEase: "ease",
              adaptiveHeight: true,
              autoplay: self.data('autoplay'),
              autoplaySpeed: self.data('autoplaySpeed'),
              nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg></button>',
              prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg></button>',
              responsive: [{
                breakpoint: 1280,
                settings: {
                  arrows: false,
                  dots: self.data('dots'),
                }
              },
              {
                breakpoint: 768,
                settings: {
                  arrows: false,
                  dots: true
                }
              }
              ]
            });
          };
        });
      };
    },

    initSliderFeaturedProducts: function () {
      var featuredProduct = $('[data-featured-products]');

      featuredProduct.each(function () {
        var self = $(this),
        productGrid = self.find('.products-grid'),
        gridItemWidth = productGrid.data('row'),
        hasRightSidebar = $('.halo-product-content .pro-page [data-has-right-sidebar]');

        if(productGrid.not('.slick-initialized')) {
          productGrid.slick({
            get slidesToShow() {
              if (hasRightSidebar.length) {
                return this.slidesToShow = 5;
              } else {
                return this.slidesToShow = productGrid.data('row');
              }
            },

            get vertical() {
              if(productGrid.hasClass('verticle')) {
                return this.vertical = true;
              }else {
                return this.vertical = false;
              }
            },

            get slidesToScroll() {
              if(productGrid.hasClass('verticle')) {
                return this.slidesToScroll = 1;
              }else {
                return this.slidesToScroll = productGrid.data('row');
              }
            },

            speed: 1000,
            infinite: false,

            get dots() {
              if(self.hasClass('has-banner')) {
                return this.dots = true;
              }else {
                return this.dots = false;
              };
            },

            nextArrow: `
              <button type="button" class="slick-next">
                <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.933594 12.0235C1.17767 11.1972 1.81838 9.51008 3.2981 8.11562C4.22865 7.23763 5.17445 6.77281 5.81515 6.53179C5.17445 6.29078 4.2439 5.82596 3.2981 4.94796C1.81838 3.53629 1.17767 1.84917 0.933594 1.04004" stroke="#4E505B" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>`,
            prevArrow: `
              <button type="button" class="slick-prev">
                <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.9668 12.171C5.72272 11.3447 5.08201 9.65754 3.60229 8.26308C2.67174 7.38509 1.72594 6.92027 1.08524 6.67925C1.72594 6.43824 2.65649 5.97342 3.60229 5.09543C5.08201 3.68375 5.72272 1.99663 5.9668 1.1875" stroke="#4E505B" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>`,
            responsive: [
            {
              breakpoint: 1400,
              settings: {
                get slidesToShow() {
                  if(self.hasClass('has-banner')) {
                    return this.slidesToShow = 3;
                  }else {
                    if(gridItemWidth > 5) {
                      return this.slidesToShow = 5;
                    }
                    else {
                      return this.slidesToShow = productGrid.data('row');
                    }
                  }
                },
                get slidesToScroll() {
                  if (self.hasClass('has-banner')) {
                    return this.slidesToScroll = 3;
                  }else {
                    if(productGrid.hasClass('verticle')) {
                      return this.slidesToScroll = 1;
                    }else {
                      if(gridItemWidth >= 4) {
                        return this.slidesToScroll = 4;
                      }else if(gridItemWidth = 3) {
                        return this.slidesToScroll = 3;
                      }else {
                        return this.slidesToScroll = 2;
                      }
                    }
                  };
                }
              }
            },
            {
              breakpoint: 1200,
              settings: {
                dots: true,
                arrows: false,
                vertical: false,
                get slidesToShow() {
                  if(self.hasClass('has-banner')) {
                    return this.slidesToShow = 2;
                  }else {
                    if(gridItemWidth >= 4) {
                      return this.slidesToShow = 4;
                    }else if(gridItemWidth = 3) {
                      return this.slidesToShow = 3
                    }else {
                      return this.slidesToShow = 2
                    }
                  }
                },
                get slidesToScroll() {
                  if (self.hasClass('has-banner')) {
                    return this.slidesToScroll = 2;
                  }else {
                    if(gridItemWidth >= 4) {
                      return this.slidesToScroll = 4;
                    }else if(gridItemWidth = 3) {
                      return this.slidesToScroll = 3
                    }else {
                      return this.slidesToScroll = 2
                    }
                  };
                }
              }
            },
            {
              breakpoint: 992,
              settings: {
                dots: true,
                arrows: false,
                vertical: false,
                get slidesToShow() {
                  if(gridItemWidth >= 3) {
                    return this.slidesToShow = 3;
                  }else {
                    return this.slidesToShow = 2
                  }
                },
                get slidesToScroll() {
                  if(gridItemWidth >= 3) {
                    return this.slidesToScroll = 3;
                  }else {
                    return this.slidesToScroll = 2
                  }
                }
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: false,
                vertical: false,
                dots: true
              }
            }
            ]
          });
        };
      });
    },

    initBannerModules: function() {
      var $banner = $(".js-banner-modules");
      var self = this;

      var sliderConfig = {
        arrows: false,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 999999,
            settings: "unslick"
          },
          {
            breakpoint: 1024,
            settings: {
              dots: true,
              slidesToShow: 1
            }
          }
        ]
      };

      function setSliderTheme(slick, slideIndex) {
        var $slide = $(slick.$slides.get(slideIndex));
        if($slide.data("class") === "color-light") {
          $banner.addClass("light-theme");
        } else {
          $banner.removeClass("light-theme");
        }
      }

      function initializeSlider() {
        $banner.slick(sliderConfig);
      }

      if($banner.length) {
        $banner.on('init', function(event, slick) {
          setSliderTheme(slick, 0);
        });

        $banner.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          setSliderTheme(slick, nextSlide);
        });

        $banner.on('afterChange', function(event, slick, currentSlide) {
          var category = self.getClosestTrackingCategory($banner);
          $("body").trigger("tracking_event", {
            category: category,
            action: `Module - Slide`,
            label: currentSlide + 1
          });
        });

        initializeSlider();

        const mediaQuery = '(max-width: 1024px)';
        const mediaQueryList = window.matchMedia(mediaQuery);

        mediaQueryList.addEventListener('change', event => {
          if (event.matches) {
            if(!$banner.hasClass('slick-initialized')) {
              initializeSlider();
            }
          }
        });
      }
    },

    initBrandsSlider: function () {
      var brandsSlider = $('[data-brands-slider]');

      brandsSlider.each(function () {
        var self = $(this);

        if (self.not('.slick-initialized')) {
          self.slick({
            slidesToShow: self.data('rows'),
            slidesToScroll: 1,
            dots: false,
            infinite: false,
            speed: 800,
            nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
            prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
            responsive: [{
              breakpoint: 1200,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
            ]
          });
        }
      });
    },

    initDropdownMenu: function() {
      var $dropdown = $(".menu-mobile .has-submenu");

      if ($dropdown.length) {
          $dropdown.off("click.slideToggle").on("click.slideToggle", function() {
            $(this).next().slideToggle();
            $(this).toggleClass("open");
          });
        }
    },

    initTracking: function () {
      var self = this;

      this.gaRetryCounter = 0;

      body.on("click.tracking", '[data-tracking-click]', function(e) {
        self.handleTrackingEvent(e);
      });

      body.on("click.tracking.hotjar", '[data-hj-trigger]', function(e) {
        self.handleTriggerHotjar(e)
      });

      body.on("submit.tracking", '[data-tracking-submit]', function(e) {
        self.handleTrackingSubmit(e);
      });

      body.on("tracking_event", function(e, data={}) {
        self.gaSendEvent({
          action: data.action,
          category: data.category,
          label: data.label
        });
      });
    },

    handleTrackingEvent: function(e) {
      const $target = $(e.currentTarget);
      let category = $target.data("event-category");
      if(!category) {
        category = this.getClosestTrackingCategory($target) || "Click Tracking";
      }
      const action = $target.data("event-action");
      let label = $target.data("event-label");
      if(!label) {
        label = $target.text().trim();
      }

      this.gaSendEvent({
        action,
        category,
        label
      });
    },

    handleTrackingSubmit: function(e) {
      const $target = $(e.currentTarget);
      const category = $target.data("event-category");
      const action = $target.data("event-action");

      const $input = $target.find('[data-tracking-form-input]');
      const label = $input.val();

      if(label) {
        this.gaSendEvent({
          action,
          category,
          label
        });
      }
    },

    gaSendEvent: function({action, category, label}) {
      var self = this;
      if(window.ga) {
        const params = {
          hitType: 'event',
          eventAction: action,
          eventCategory: category || 'Web',
          eventLabel: label
        };

        ga('send', params);
      } else if(self.gaRetryCounter++ <= 10) {
        var retry = function() {
          self.gaSendEvent({action, category, label});
        };
        setTimeout(retry, 500);
      }
    },

    getClosestTrackingCategory: function($el) {
      return $el.closest("[data-event-category]").data("event-category");
    },

    handleTriggerHotjar: function (e) {
      window.hj = window.hj || function(){(hj.q=hj.q||[]).push(arguments)};
      const $target = $(e.currentTarget);
      const trigger = $target.data('hj-trigger');
      if(trigger) {
        hj("tagRecording", ["js_trigger", trigger]);
        hj("trigger", trigger);
      }
    },

    closeTranslate: function (closeElm, classRemove) {
      if ($(closeElm).length) {
        body.off('click.closeCustomer', closeElm).on('click.closeCustomer', closeElm, function (e) {
          e.preventDefault();
          e.stopPropagation();

          html.removeClass(classRemove);
        });
      };
    },

    updateDropdownCart: function () {
      Shopify.getCart(function (cart) {
        html.trigger("refresh_cart", {cart: cart});
        html.toggleClass("cart-show");
      });
    },

    initLoading: function() {
      body.on("loading_show", this.showLoading);
      body.on("loading_hide", this.hideLoading);
    },

    showLoading: function () {
      $('.loading-modal').show();
    },

    hideLoading: function () {
      $('.loading-modal').hide();
    },

    showModal: function (selector) {
      $(selector).fadeIn(500);

      ella.ellaTimeout = setTimeout(function () {
        $(selector).fadeOut(500);
      }, 5000);
    },

    initCountdown: function () {
      var countdownElm = $('[data-countdown]');

      countdownElm.each(function () {
        var self = $(this),
        countdownValue = self.data('countdown-value');

        self.countdown(countdownValue, function (event) {
          $(this).html(event.strftime('' +
            '<div class="clock-item"><span class="num">%D</span><span>days</span></div>' +
            '<div class="clock-item"><span class="num">%H</span><span>hours</span></div>' +
            '<div class="clock-item"><span class="num">%M</span><span>mins</span></div>' +
            '<div class="clock-item"><span class="num">%S</span><span>secs</span></div>'));
        });
      });
    },

    initCountdownNormal: function () {
      var countdownElm = $('[data-countdown-normal]');

      countdownElm.each(function () {
        var self = $(this),
        countdownValue = self.data('countdown-value');

        if(self.hasClass('countdown-suppermarket')) {
          self.countdown(countdownValue, function (event) {
            $(this).html(event.strftime('' +
              '<div class="clock-item"><span class="num">%D</span><span>d</span></div>' +
              '<div class="clock-item"><span class="num">%H</span>&nbsp;:</div>' +
              '<div class="clock-item"><span class="num">%M</span>&nbsp;:</div>' +
              '<div class="clock-item"><span class="num">%S</span></div>'));
          });
        } else {
          self.countdown(countdownValue, function (event) {
            $(this).html(event.strftime('' +
              '<div class="clock-item"><span class="num">%D</span><span>D</span>:</div>' +
              '<div class="clock-item"><span class="num">%H</span><span>H</span>:</div>' +
              '<div class="clock-item"><span class="num">%M</span><span>M</span>:</div>' +
              '<div class="clock-item"><span class="num">%S</span><span>S</span></div>'));
          });
        }
      });
    },

    initToggleSubMenuMobile: function () {
      var mainMenu = $('.main-menu.jas-mb-style'),
      siteNav = $('.site-nav'),
      iconDropdown = siteNav.find('[data-toggle-menu-mb]');

      iconDropdown.off('click.dropdownMenu').on('click.dropdownMenu', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var curParent = $(this).parent(),
        curMenu = curParent.next('.sub-menu-mobile');

        if (curMenu.hasClass('sub-menu-open')) {
          curMenu.removeClass('sub-menu-open');
        } else {
          curMenu.addClass('sub-menu-open').css({
            "overflow": ""
          });
          mainMenu.animate({
            scrollTop: 0
          }, 0);
          mainMenu.css({
            "overflow": "hidden"
          });
        };
      });

      ella.linkClickToggleSubMenuMobile(mainMenu);
    },

    linkClickToggleSubMenuMobile: function (mainMenu) {
      var menuMobile = $('.site-nav .dropdown'),
      iconDropdown = menuMobile.find('[data-toggle-menu-mb]'),
      menuMobileLabel = $('.sub-menu-mobile .menu-mb-title');

      if (iconDropdown.length && iconDropdown.is(':visible')) {
        menuMobile.off('click.current').on('click.current', function (e) {
          e.stopPropagation();

          $(this).children('.sub-menu-mobile').addClass('sub-menu-open').css({
            "overflow": ""
          });
          mainMenu.animate({
            scrollTop: 0
          }, 0);
          mainMenu.css({
            "overflow": "hidden"
          });
        });

        menuMobile.find('.menu__moblie').on('click', function (e) {
          e.stopPropagation();
        });

        menuMobileLabel.off('click.closeMenu').on('click.closeMenu', function (e) {
          e.preventDefault();
          e.stopPropagation();

          if($(this).parent().hasClass('bg')) {
            $(this).parent().parent().removeClass('sub-menu-open');
          }else {
            $(this).parent().removeClass('sub-menu-open');
          };

          if (!$(this).closest('.menu-lv-2').length) {
            mainMenu.css({
              "overflow": ""
            });
          };
        })
      };
    },

    initInfiniteScrolling: function () {
      var infiniteScrolling = $('.infinite-scrolling');
      var infiniteScrollingLinkSlt = '.infinite-scrolling a';

      if (infiniteScrolling.length) {

        body.off('click.initInfiniteScrolling', infiniteScrollingLinkSlt).on('click.initInfiniteScrolling', infiniteScrollingLinkSlt, function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (!$(this).hasClass('disabled')) {
            var url = $(this).attr('href');

            ella.doAjaxInfiniteScrollingGetContent(url);
          };
        });

        if (window.infinity_scroll_feature) {
          $(window).on("scroll", function () {
            if (ella.isAjaxLoading) return;

            var collectionTplElm = $('[data-section-type="collection-template"]');

            if (!collectionTplElm.length) {
              collectionTplElm = $('[data-search-page]');
            };

            var collectionTop = collectionTplElm.offset().top;
            var collectionHeight = collectionTplElm.outerHeight();
            var posTop = collectionTop + collectionHeight - $(window).height();

            if ($(this).scrollTop() > posTop && $(this).scrollTop() < (posTop + 200)) {
              var button = $(infiniteScrollingLinkSlt);

              if (button.length && !button.hasClass('disabled')) {
                var url = button.attr('href');

                ella.doAjaxInfiniteScrollingGetContent(url);
              };
            };
          });
        };
      }
    },

    doAjaxInfiniteScrollingGetContent: function (url) {
      if (ella.isAjaxLoading) return;

      $.ajax({
        type: "get",
        url: url,

        beforeSend: function () {
          ella.showLoading();
        },

        success: function (data) {
          ella.ajaxInfiniteScrollingMapData(data);
          ella.initCountdownNormal();
        },

        error: function (xhr, text) {
          $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          ella.showModal('.ajax-error-modal');
        },

        complete: function () {
          ella.hideLoading();
        }
      });
    },

    ajaxInfiniteScrollingMapData: function (data) {
      var collectionTemplate = $('.collection-template'),
      currentProductColl = collectionTemplate.find('.product-collection'),
      newCollectionTemplate = $(data).find('.collection-template'),
      newProductColl = newCollectionTemplate.find('.product-collection'),
      newProductItem = newProductColl.children('.grid-item').not('.banner-img');

      showMoreButton = $('.infinite-scrolling a');

      if (newProductColl.length) {
        currentProductColl.append(newProductItem);

        if ($('.collection-template .product-collection[data-layout]').length) {
          ella.ellaTimeout = setTimeout(function () {
            currentProductColl.isotope('appended', newProductItem).isotope('layout');
          }, 700);
        }

        if ($(data).find('.infinite-scrolling').length > 0) {
          showMoreButton.attr('href', newCollectionTemplate.find('.infinite-scrolling a').attr('href'));
        } else {
          //no more products
          var noMoreText = window.inventory_text.no_more_product;
          showMoreButton.html(noMoreText).addClass('disabled');
        }
      };
    },

    initAddToCart: function () {
      var btnAddToCartSlt = '[data-btn-addToCart]';
      var $btn = $(btnAddToCartSlt);

      doc.off('click.addToCart', btnAddToCartSlt).on('click.addToCart', btnAddToCartSlt, function (e) {
        e.preventDefault();
        e.stopPropagation();

        var self = $(this);

        if (self.attr('disabled') !== "disabled") {
          var productItem = self.closest('.product-item');

          if (productItem.length < 1) {
            var sectionsProduct = self.closest('[data-section-type="product"]');
            productItem = sectionsProduct.find('.product-shop');
          };

          var form = productItem.find('form');
          
          var variant_id = form.find('select[name=id]').val();
          if (!variant_id) {
            variant_id = form.find('input[name=id]').val();
          };

          var quantity = form.find('input[name=quantity]').val();
          if (!quantity) {
            quantity = 1;
          };

          var originalPrice = form.find('input[name="price-original"]').val();

          switch (window.ajax_cart) {
            case "none":
              form.submit();
              break;

            case "normal":
              ella.doAjaxAddToCartNormal({variant_id, quantity, originalPrice});
              break;
          };

        }
        return false;
      });
      $btn.attr('disabled', false);
      $btn.removeClass("product__btn-cart-loading");
      $btn.find(".js-addtocart-loading").hide();
      $btn.find(".js-addtocart-content").show();
    },

    doAjaxAddToCartNormal: function({variant_id, quantity, originalPrice}) {
      var properties = {};
      if(originalPrice) {
        properties.original_price = originalPrice;
      }

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          id: variant_id,
          quantity: quantity,
          properties
        },
        dataType: "json",

        beforeSend: function () {
          ella.showLoading();
        },

        success: function () {
          //ella.updateDropdownCart();
          window.location = `${window.Shopify.routes.root}cart`;
        },

        error: function (xhr) {
          $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          ella.showModal('.ajax-error-modal');
        },

        complete: function () {
          ella.hideLoading();
        }
      });
    },

    changeSwatch: function (swatchSlt) {
      doc.on('change', swatchSlt, function () {
        var className = $(this).data('filter');
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();

        $(this)
        .closest('form')
        .find('.single-option-selector')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');
      });
    },

    productPageInitProductTabs: function () {
      var listTabs = $('.tabs__product-page'),
      tabLink = listTabs.find('[data-tapTop]'),
      tabContent = listTabs.find('[data-TabContent]');

      tabLink.off('click').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var curTab = $(this),
        curTabContent = $(curTab.data('target')),
        ulElm = curTab.closest('.list-tabs');

        if (ulElm.length) {
          if (!$(this).hasClass('active')) {
            tabLink.removeClass('active');
            tabContent.removeClass('active');

            curTab.addClass('active');
            ulElm.next().find(curTab.data('target')).addClass('active');
          }
        } else {
          if (!$(this).hasClass('active')) {
            curTab.addClass('active');
            curTabContent.slideDown();
          } else {
            curTab.removeClass('active');
            curTabContent.slideUp();
          }
        };
      });
    },

    initSearch: function () {
      var $search = $(".js-header-search .js-search-bar");
      var $searchInput = $search.find(".js-search-input");
      doc.on('click.searchTrigger', '.js-search-trigger', function (e) {
        $search.addClass("open");
        $searchInput.trigger("focus");

        doc.off('click.searchToggle').on('click.searchToggle', function(e) {
          if (!$search.is(e.target) && !$search.has(e.target).length) {
            $search.removeClass("open");
            doc.off("click.searchToggle");
          }
        });
      });
    },

    wrapTable: function(){
      var table = $('.tab-content').find('table');
      if(table.length){
        table.each(function(){
          $(this).wrap('<div class="table-wrapper"></div>')
        })
      }
    },
  }
})(jQuery);